import {useTranslation} from 'react-i18next'
import {Tag} from '@/components/ui/tag'
import {formatDateOnly} from '@/lib/risk'

/** Neutro como «Activo» (U2(a)): los dos lados del booleano son identidad y ninguno exige nada. */
export function InactiveBadge({since, testId}: {since?: string | null; testId?: string}) {
  const {t} = useTranslation()
  return (
    <Tag tone="neutral" data-testid={testId}>
      {since
        ? t('employees.inactiveSince', {date: formatDateOnly(since.slice(0, 10))})
        : t('employees.status.inactive')}
    </Tag>
  )
}
